import 'vue-image-lightbox/dist/vue-image-lightbox.min.css';
import Vue from 'vue';
import axios from 'axios';
import vClickOutside from 'v-click-outside';
import VButton from '@/components/VButton.vue';
import VModal from '@/components/VModal.vue';
import VLoader from '@/components/VLoader.vue';
import VeeValidate from 'vee-validate';
import StepSection from '@/components/StepSection.vue';
import StepBlock from '@/components/StepBlock.vue';
import VueMq from 'vue-mq';
import App from './App.vue';
import router from './router';
import store from './store/index';
import i18n from './i18n';
import './styles/main.scss';

Vue.config.productionTip = false;

Vue.use(VeeValidate, {
  inject: false,
});
Vue.use(VueMq, {
  breakpoints: {
    xs: 420,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xle: 1300,
  },
});
Vue.use(vClickOutside);

axios.defaults.baseURL = window.$ENV.API_HOST;
axios.interceptors.request.use(config => {
  const apiKey = window.$ENV.API_KEY;

  if (apiKey && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${apiKey}`;
  }

  return config;
});




// Global components
Vue.component('VButton', VButton);
Vue.component('VModal', VModal);
Vue.component('VLoader', VLoader);
Vue.component('StepSection', StepSection);
Vue.component('StepBlock', StepBlock);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
